<template>
    <div class="indemnity-detail-container">
        <typo name="body-14-normal" v-if="indemnity.minimumSeniority">
            Ancienneté minimum : {{ indemnity.minimumSeniority }}
            {{ getOptionLabel(indemnity.minimumSeniorityUnit) }}
        </typo>
        <typo name="body-14-normal" v-if="indemnity.ceiling">
            Plafond : {{ indemnity.ceiling }}
            {{ getOptionLabel(indemnity.ceilingUnit) }}
        </typo>
        <typo name="body-14-normal" v-if="indemnity.floor">
            Planché : {{ indemnity.floor }}
            {{ getOptionLabel(indemnity.floorUnit) }}
        </typo>
    </div>
</template>

<script>
import { get } from "lodash";

export default {
    props: ["indemnity", "annotationOptions"],
    methods: {
        getOptionLabel(code) {
            return get(this.annotationOptions, `${code}.label`, "");
        },
    },
};
</script>

<style scoped lang="sass">
.indemnity-detail-container
    display: flex
    flex-direction: column
    width: 250px
    margin: 0 16px
    padding: 0 16px
</style>
